/**
 * Если надо подменить общий подход к построению url для новых апи, то надо указать
 * env переменную `CEN_bundle_internal_url_pattern` равной чему-то подобному `https://dev.xapilb.centra.ai/{API_NAME}`.
 * При этому бывают случаи, надо заменить url только для некоторых апи.
 * В этом случае дополнительно (!) к CEN_bundle_internal_url_pattern добавьте переменную `CEN_bundle_internal_url_{API_NAME}`,
 * где в API_NAME дефисы заменены на нижние подчеркивания. Например для апи `api-store-recommendations` имя env-а
 * будет таким `CEN_bundle_internal_url_api_store_recommendations`.
 * В этом случае для этого апи приоритетно будет применен именно этот ключ, а если ключа или значения в нем не будет,
 * то функция отработает по паттерну из `CEN_bundle_internal_url_pattern`.
 */
export const buildApiUrl = (apiName: string) => {
  const lowerBundleName = apiName.replace(/-/g, '_');
  const bundleUrlEnvKey = `CEN_bundle_internal_url_${lowerBundleName}`;
  const value = process.env[bundleUrlEnvKey];

  if (value) {
    return value;
  }
  // внутри куба это примерно такое `http://{BUNDLE}-dev-common.dev.svc.cluster.local`
  // для работы из под VPN тут ждем что-то такое `http://{BUNDLE}-dev.bundle.centra.ai`
  // для публично доступного url https://dev.xapilb.centra.ai/{BUNDLE}
  return `${process.env.CEN_bundle_internal_url_pattern}`.replace('{BUNDLE}', apiName);
};
